import { useContext } from 'react';

import { PreparedWorkload } from '@cast/split-me/features/workload-optimization';
import { SearchProvider } from '@cast/shared-search-ui';

import {
  Filters,
  useWorkloadsTableCriteria,
  OptimizationWorkloadsListContext,
} from '@cast/split-me/features/cluster/workload-optimization';

import { inventoryWorkloadsTableKeys } from '../../../../../consts';
import { WorkloadsTable } from './_components/WorkloadsTable';

export const TableSection = () => {
  const { workloads, isLoading, hasError } = useContext(
    OptimizationWorkloadsListContext
  );

  const criteria = useWorkloadsTableCriteria({
    includeWorkloadTypeInSearchBox: true,
  });

  return (
    <SearchProvider<PreparedWorkload>
      criteria={criteria}
      data={workloads}
      isLoading={isLoading}
      urlKey={inventoryWorkloadsTableKeys.AUTOSCALING}
    >
      {!hasError && <Filters />}
      <WorkloadsTable />
    </SearchProvider>
  );
};
